import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"

const AMAZON_PROMO_CODE = "2022HINTP9"

export const AmazonGetStartedComponent = () => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(AMAZON_PROMO_CODE)

  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (promoCode) => ({ disabled, handleClick }) => {
    return (
      <>
        <Button
          type="button"
          className="btn"
          primary
          disabled={disabled}
          onClick={() => {
            setSubmissionPromoCode(promoCode)
            handleClick()
          }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    getButton(
      AMAZON_PROMO_CODE
    )
  ]

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
          <p>
            Enter your T-Mobile phone number to begin the redemption process. You will then be prompted to log in to your account.
          </p>
          <p>
            If you are a Home Internet only customer, please find your assigned billing phone number on your bill under "connected devices."
          </p>
            <img style={{ marginTop: "1rem" }} src={"images/Amazon/Amazon_logo.png"} alt="Amazon Logo" className="mb-3" />
            <p>
            New T-Mobile Home Internet customers can get the Echo Show 8 (2nd Gen) On Us—a $129.99 value.
            </p>
          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{ marginBottom: "6px" }}>
            <b>Start by entering your phone number</b>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto" />
        </div>
        <div className="mx-auto col-md-4">
          <p>
            Questions before you continue?
            Find answers <a href="https://www.t-mobile.com/content/t-mobile/consumer/isp/FAQ.html" target="_blank" rel="noopener noreferrer">here</a>.
          </p>
        </div>
      </div>
    </section>
  )
}
